// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yjDte","btn":"styles_btn__8OlJc","active":"styles_active__Jz-q3"};